<template>
  <div>
    <div class="row margin-half-top">
      <div class="col-md-12">
        <div class="">
          <div class="card-header">
            <btn-rounded
              label="DADOS"
              event="showView"
              params="profile"
              :fill="activeView === 'profile'"
            />
            <btn-rounded
              label="IMAGENS"
              event="showView"
              params="gallery"
              :fill="activeView === 'gallery'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-1" v-if="activeView === 'profile'">
          <button
            class="btn btn-rounded btn-fill"
            :class="[
              { ' btn-success': !localReadonly },
              { ' btn-warning': localReadonly },
            ]"
            style="padding-left: 10px; padding-right: 10px"
            v-on:click="unlock()"
          >
            <i
              :class="[
                { 'ti-unlock': !localReadonly },
                { 'ti-lock': localReadonly },
              ]"
            ></i>
          </button>
        </div>
        <div class="col-md-12">
          <mining-form
            :data="data"
            :readonly="localReadonly"
            :edit="true"
            :activeView="activeView"
            event="save"
          />
        </div>
      </div>
    </div>

    <div class="col-md-12 text-right" v-if="!localReadonly && activeView === 'profile'">
      <btn-rounded label="SALVAR" event="save" />
    </div>
  </div>
</template>
<script>
import MiningForm from "src/components/UIComponents/Forms/MiningForm.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Notifications from "vue-notification";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Notifications);
Vue.use(Viewer);

export default {
  components: {
    MiningForm,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  props: {},
  computed: {
    ...mapState({}),
  },
  watch: {
    $route: "initData",
  },
  methods: {
    ...mapActions(["updateCar", "getCar", "deleteCarImage"]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
    initData() {
      this.data = this.$route.params.id;
      this.verifyID();
      // if (this.data.CarImages) {
      //   this.data.CarImages.sort((a, b) => (a.updatedAt > b.updatedAt ? 1 : -1));
      // }
    },
    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },

    verifyID() {
      if (this.data == undefined) {
        this.$router.push({
          name: "Anúncios - Lista",
        });
      }
    },
  },

  data() {
    return {
      localReadonly: false,
      data: null,
      readonly: true,
      activeView: "profile",
    };
  },

  created() {
    this.initData();
    this.localReadonly = this.readonly;

    this.$on("updateData", (item) => {
      this.data = item
      this.data.CarImages.push({})
      this.data.CarImages.pop()

    })

    this.$on("deleteImages", (item) => {
      let sendCarImage = {
        id: item.CarImageId
      }
      // let sendCarId = item.id
      
      
      this.deleteCarImage(sendCarImage).then(() => {
        this.data.CarImages.splice(_.findIndex(this.data.CarImages, {id: sendCarImage.id}), 1);
        console.log(this.data.CarImages)
        let sen = this.data 

        this.data = sen
        
        // this.getCar(sendCarId).then((res) => {
        //   this.data = res
        // })
      })
    })

    this.$on("showView", (view) => {
      this.activeView = view;
    });

    this.$on("save", () => {
      this.updateCar(this.data)
        .then((res) => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success",
          });
          this.localReadonly = true;
        })
        .catch((res) => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error",
          });
        });
    });
  },
};
</script>
<style lang="scss" scoped>
.card-image {
  border: solid 1px white;
  padding: 15px;
  background-color: #f0f0f0;
}

.rotateimg90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.rotateimg270 {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}

.images {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mining/miningEdit.vue